import shortName from './shortName';
import hrDate from './hrDate';
import hrDateTime from './hrDateTime';
import hrMoney from './hrMoney';

export default {
	install (Vue) {
		Vue.filter('short_name', shortName);
		Vue.filter('hr_date', hrDate);
		Vue.filter('hr_datetime', hrDateTime);
		Vue.filter('hr_money', hrMoney);
	}
}



// WEBPACK FOOTER //
// ./src/filters/index.js